import { defineMessages } from 'react-intl'

// Constants
import { MSG_REOPEN_JOB_TABLE_ROW_BTN } from 'hfty-reopen-job-dom'
import {
  ATTR_SOIL_JOB_ID,
  ATTR_CREATED_DATE,
  ATTR_SEASON,
  ATTR_FARM,
  ATTR_FIELD,
  ATTR_GRID_SIZE,
  ATTR_AREA,
  ATTR_PRICE,
  ATTR_STATUS,
  ATTR_MAP_VIEW,
  ATTR_LAB_RESULTS,
  ATTR_COMMENTS,
  ATTR_RECOMMENDATIONS,
  ATTR_REOPEN_JOB,
} from './constants'

export default defineMessages({
  [ATTR_SOIL_JOB_ID]: {
    id: 'hfty.dataTable.soiljobs.id',
    defaultMessage: 'ID',
  },
  [ATTR_CREATED_DATE]: {
    id: 'hfty.dataTable.soiljobs.createdDate',
    defaultMessage: 'Created Date',
  },
  [ATTR_FARM]: {
    id: 'hfty.dataTable.farm',
    defaultMessage: 'Farm',
  },
  [ATTR_FIELD]: {
    id: 'hfty.dataTable.field',
    defaultMessage: 'Field',
  },
  [ATTR_SEASON]: {
    id: 'hfty.dataTable.soiljobs.season',
    defaultMessage: 'Season',
  },
  [ATTR_GRID_SIZE]: {
    id: 'hfty.dataTable.soiljobs.grid_size',
    defaultMessage: 'Grid Size',
  },
  [ATTR_AREA]: {
    id: 'hfty.dataTable.soiljobs.area',
    defaultMessage: 'Area',
  },
  [ATTR_PRICE]: {
    id: 'hfty.dataTable.soiljobs.price',
    defaultMessage: 'Price',
  },
  [ATTR_STATUS]: {
    id: 'hfty.dataTable.soiljobs.status',
    defaultMessage: 'Status',
  },
  [ATTR_MAP_VIEW]: {
    id: 'hfty.dataTable.soiljobs.map_view',
    defaultMessage: 'Map View',
  },
  [ATTR_LAB_RESULTS]: {
    id: 'hfty.dataTable.soiljobs.lab_results',
    defaultMessage: 'Lab Results',
  },
  [ATTR_COMMENTS]: {
    id: 'hfty.dataTable.soiljobs.comments',
    defaultMessage: 'Comments',
  },
  [ATTR_RECOMMENDATIONS]: {
    id: 'hfty.dataTable.soiljobs.recommendations',
    defaultMessage: 'Recommendations',
  },
  [ATTR_REOPEN_JOB]: {
    id: 'reopenJob.tableHeading',
    defaultMessage: 'Reopen job',
  },
  [MSG_REOPEN_JOB_TABLE_ROW_BTN]: {
    id: 'reopenJob.tableRowButton',
    defaultMessage: 'Reopen job',
  },
})
